import { handleActions } from 'redux-actions';

const INITIAL_STATE = {
  interest: [],
  need: [],
  breed: [],
  dogsize: [],
  city: [],
  charity: [],
  locality: [],
  localitydistrict: [],
  suburb: [],
};

/**
 * Application props via this.props.appdata in connected components
 */
const applicationData = handleActions(
  {
    UPDATE_APP_DATA: (state, action) => Object.assign({}, state, action.payload),
  },
  INITIAL_STATE,
);

export default applicationData;



// WEBPACK FOOTER //
// ./src/reducers/applicationData.js